// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2wDmO","label":"Section_label__3khLk","contentWrap":"Section_contentWrap__3bEmJ","footer":"Section_footer__3YTzR","footerInner":"Section_footerInner__aRfIm"};